import { Typography } from '@mui/material';
import { useResponsive } from '@/components/hooks/useResponsive';
import { seoSegmentationListingPage_seoSegmentationSearchResults_SEOSegmentationSearchResultsSuccess_providerSearchResults_seoSegmentationProvider_provider as Provider } from '@/__generated__/seoSegmentationListingPage';

interface SMBLocationProps {
  address: NonNullable<Provider['address']>;
}

export const SMBLocation = ({ address }: SMBLocationProps) => {
  const { isSmallViewport } = useResponsive();

  return (
    <Typography variant={isSmallViewport ? 'body3' : 'body2'}>
      {address.addressLine1}
      {isSmallViewport ? <br /> : '\u00A0'}
      {address.city}, {address.state}
    </Typography>
  );
};
